import { useState } from "react";

const mockServices = [
  { id: 1, name: "GST Monthly Filing", frequency: "Monthly" },
  { id: 2, name: "TDS Returns", frequency: "Quarterly" },
  { id: 3, name: "Statutory Audit", frequency: "Yearly" }
];

const ClientServiceSubscription = () => {

  const [subscriptions, setSubscriptions] = useState({});

  const toggleService = (serviceId) => {
    setSubscriptions(prev => ({
      ...prev,
      [serviceId]: {
        ...prev[serviceId],
        active: !prev[serviceId]?.active
      }
    }));
  };

  const updateField = (serviceId, field, value) => {
    setSubscriptions(prev => ({
      ...prev,
      [serviceId]: {
        ...prev[serviceId],
        [field]: value
      }
    }));
  };

  return (
    <div>

      <h3 className="text-lg font-black text-slate-900 mb-4">
        Service Subscriptions
      </h3>

      <div className="bg-white border rounded-2xl overflow-hidden">

        <table className="w-full text-sm">

          <thead className="bg-slate-50 text-slate-500">
            <tr>
              <th className="text-left px-4 py-3">Service</th>
              <th className="text-left px-4 py-3">Frequency</th>
              <th className="text-left px-4 py-3">Active</th>
              <th className="text-left px-4 py-3">Configuration</th>
            </tr>
          </thead>

          <tbody>

            {mockServices.map(service => {

              const sub = subscriptions[service.id] || {};

              return (
                <tr key={service.id} className="border-t">

                  <td className="px-4 py-3 font-semibold text-slate-900">
                    {service.name}
                  </td>

                  <td className="px-4 py-3 text-slate-500">
                    {service.frequency}
                  </td>

                  {/* TOGGLE */}
                  <td className="px-4 py-3">
                    <input
                      type="checkbox"
                      checked={sub.active || false}
                      onChange={() => toggleService(service.id)}
                    />
                  </td>

                  {/* CONFIG */}
                  <td className="px-4 py-3">

                    {sub.active && (
                      <div className="grid md:grid-cols-3 gap-2">

                        <input
                          type="date"
                          className="border rounded px-2 py-1"
                          onChange={e =>
                            updateField(service.id, "startDate", e.target.value)
                          }
                        />

                        <input
                          type="date"
                          className="border rounded px-2 py-1"
                          onChange={e =>
                            updateField(service.id, "endDate", e.target.value)
                          }
                        />

                        <input
                          placeholder="Assigned Manager"
                          className="border rounded px-2 py-1"
                          onChange={e =>
                            updateField(service.id, "manager", e.target.value)
                          }
                        />

                      </div>
                    )}

                  </td>

                </tr>
              );
            })}

          </tbody>

        </table>

      </div>

    </div>
  );
};

export default ClientServiceSubscription;
